import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()(()=> {
    return {
            tourCanvas: {
                width: '100%',
                height: '100%'
            }
        }
})